
import { DataEngineeringCourse } from './types';
import { DATAENGINEERING_FUNDAMENTALS_COURSE } from './fundamentals';
import { DATAENGINEERING_INTERMEDIATE_COURSE } from './intermediate';
import { DATAENGINEERING_ADVANCED_COURSE } from './advanced';

export const DATAENGINEERING_COURSES: DataEngineeringCourse[] = [
  DATAENGINEERING_FUNDAMENTALS_COURSE,
  DATAENGINEERING_INTERMEDIATE_COURSE,
  DATAENGINEERING_ADVANCED_COURSE
];

// Export individual courses for direct access
export { 
  DATAENGINEERING_FUNDAMENTALS_COURSE,
  DATAENGINEERING_INTERMEDIATE_COURSE,
  DATAENGINEERING_ADVANCED_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const DATAENGINEERING_COURSE_METADATA = {
  totalCourses: DATAENGINEERING_COURSES.length,
  totalDuration: '48-58 hours',
  levels: ['fundamentals', 'intermediate', 'advanced'],
  skillsPath: [
    'Database Design & SQL Mastery',
    'Python Programming for Data Engineering',
    'ETL/ELT Pipeline Development',
    'Data Quality & Validation',
    'Cloud Platform Integration',
    'Workflow Orchestration (Airflow)',
    'Stream Processing & Real-time Data',
    'Data Warehouse Design',
    'Big Data Technologies (Spark)',
    'API Development for Data Access',
    'Infrastructure as Code',
    'Advanced Streaming (Kafka)',
    'Data Lake & Lakehouse Architecture',
    'MLOps Integration',
    'Cost Optimization & Performance Tuning',
    'Team Leadership & Data Strategy'
  ]
};
